import { useState } from "react";
import { useNavigate } from "react-router-dom";


const menuItems = [
  { id: 1, label: "Petty Cash", route: "/pettycash" },
  { id: 2, label: "Vehicle Record", route: "/TripHistory" },
  { id: 3, label: "Duty Slip", route: "/FieldDutySlip" },
  { id: 4, label: "Log out", route: null },
];

function SignOut() {
  ["token", "name", "designation", "isAdmin", "Dept_ID", "Desg_ID",
    "is_sales", "is_account", "is_operation", "is_HR", "is_master", "super_admin"]
    .forEach((key) => localStorage.removeItem(key));
  window.location.reload();
}

export default function AppLayout({ title, onBack, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ width: "100%", height: "100vh", position: "relative", overflow: "hidden" }}>

      {/* Header */}
      <div style={{
        height: 60,
        background: "linear-gradient(135deg, #e05c8a, #7c3ab5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
        borderRadius: "0 0 20px 20px",
        flexShrink: 0,
      }}>
        
        <button
          onClick={() => setIsOpen(true)}
          style={{
            padding: "21px 0 0 0",
            background: "none",
            border: "none",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            gap: 4
          }}
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              style={{
                display: "block",
                width: 20,
                height: 2,
                background: "#fff",
                borderRadius: 2
              }}
            />
          ))}
        </button>

        {/* Center — page title */}
        <span style={{ color: "#fff", fontSize: 15, fontWeight: 500 }}>{title || ""}</span>

        {/* Right — profile icon */}
        <div style={{ width: 28 }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
            <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5z" />
          </svg>
        </div>
      </div>

      {/* Page content */}
      <div style={{ height: "calc(100% - 60px)", overflowY: "auto", background: "#f5f5f5" }}>
        {children}
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 9 }}
        />
      )}

      {/* Slide-in Menu */}
      <div style={{
        position: "absolute",
        top: 0,
        left: isOpen ? 0 : "-100%",
        width: "50%",
        height: "100%",
        background: "#fff",
        zIndex: 10,
        transition: "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
      }}>
        {/* Menu Header */}
        <div style={{
          height: 60,
          background: "linear-gradient(135deg, #e05c8a, #7c3ab5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 16px",
        }}>
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>Menu</span>
          <button
            onClick={() => setIsOpen(false)}
            style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer", textAlign: "end" }}
          >
            ✕
          </button>
        </div>

        {/* Menu Items */}
        <nav style={{ padding: "24px 20px" }}>
          {menuItems.map((item, index) => (
            <div
              key={item.id}
              onClick={() => {
                if (item.label === "Log out") {
                  SignOut();
                } else {
                  navigate(item.route);
                  setIsOpen(false);
                }
              }}
              style={{
                padding: "16px 0",
                fontSize: 15,
                color: item.label === "Log out" ? "#DC3545" : "#333",
                cursor: "pointer",
                borderBottom: index < menuItems.length - 1 ? "0.5px solid #eee" : "none",
              }}
            >
              {item.label}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
}